export default interface SubscriptionsSection {
  tierContentType?: SubscriptionsTierContentType;
  selectedTierId?: number | null;
}

export enum SubscriptionsTierContentType {
  DEVIATIONS = 'deviations',
  POSTS = 'posts',
}
